module.exports = __webpack_public_path__ + "media/images/endia_logo_x200-9455fb014ba7fa8f8e7ebc2e705a4d84.png";